export const i18nPluginDeps = ["i18n:plugin","i18n:plugin:ssg-detect","i18n:plugin:route-locale-detect"]